export const HeaderStyle = {

    header: {
        width: "100%",
        background: "#7BA238",
        display: "flex",
        justifyContent: "space-between",
        padding: "10px",
    },

    footerImage: {
        width: "auto",
    },
}